import { createFileRoute } from '@tanstack/react-router'
import AttendanceRecordsPage from '@/pages/AttendanceRecordsPage'

export const Route = createFileRoute('/$leaid/_error-wrapper/records/attendance/')({
  component: AttendanceRecordsPage,
})
